import { z } from 'zod';

const CCY = z.string().length(3).regex(/^[A-Z]{3}$/);
const DECIMAL = z.string().regex(/^\d+(\.\d{1,4})?$/);

/** Receipt = money in (سند قبض); payment = money out (سند دفع). */
export const VoucherTypeSchema = z.enum(['receipt', 'payment']);
export type VoucherType = z.infer<typeof VoucherTypeSchema>;

export const VoucherStatusSchema = z.enum(['posted', 'void']);
export type VoucherStatus = z.infer<typeof VoucherStatusSchema>;

export const VoucherSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  voucherNumber: z.string(),
  voucherType: VoucherTypeSchema,
  voucherDate: z.string(),
  partyId: z.string().uuid().nullable(),
  partyName: z.string().nullable(),
  /** Cash / bank account: received into (receipt) or paid from (payment). */
  cashAccountId: z.string().uuid(),
  cashAccountName: z.string().nullable(),
  /** The counter account: income/receivable (receipt) or expense/payable (payment). */
  counterAccountId: z.string().uuid(),
  counterAccountName: z.string().nullable(),
  amount: z.string(),
  currencyCode: z.string(),
  reference: z.string().nullable(),
  description: z.string().nullable(),
  journalEntryId: z.string().uuid().nullable(),
  status: VoucherStatusSchema,
  createdByUserId: z.string().uuid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Voucher = z.infer<typeof VoucherSchema>;

export const VoucherCreateSchema = z.object({
  voucherType: VoucherTypeSchema,
  voucherDate: z.string(),
  partyId: z.string().uuid().nullable().optional(),
  cashAccountId: z.string().uuid(),
  counterAccountId: z.string().uuid(),
  amount: DECIMAL,
  currencyCode: CCY,
  reference: z.string().max(200).nullable().optional(),
  description: z.string().max(1000).nullable().optional(),
});
export type VoucherCreate = z.infer<typeof VoucherCreateSchema>;

export const VoucherUpdateSchema = z.object({
  voucherDate: z.string().optional(),
  partyId: z.string().uuid().nullable().optional(),
  cashAccountId: z.string().uuid().optional(),
  counterAccountId: z.string().uuid().optional(),
  amount: DECIMAL.optional(),
  currencyCode: CCY.optional(),
  reference: z.string().max(200).nullable().optional(),
  description: z.string().max(1000).nullable().optional(),
});
export type VoucherUpdate = z.infer<typeof VoucherUpdateSchema>;
